import React from 'react';
import './LoadingAnimationStyle.css';

export const LoadingAnimation = () => (
  <div className="loading-text">
    <div className="loader" />
    <p>Please wait a minute</p>
  </div>
);
